import React from 'react';
import hasValidationErrors from 'components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob } from 'utils/BackgroundJobs';
import { GoodsReceiptLineLabel } from 'graphql/entities';
import { getMutationProps, getRangeMutationProps } from './DocumentAction';
import { onDocumentPrintComplete, onDocumentPrintFailed } from '../../utils/DocumentUtils';

export function generate(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    GoodsReceiptLineLabel.generate,
    getMutationProps(state, props, variables),
    props,
    returnUrl,
    'Generate Receipt Labels',
    job => onDocumentPrintComplete(state, props, job)
  );
}

export function generateRange(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    GoodsReceiptLineLabel.generateRange,
    getRangeMutationProps(state, props, variables, 'purchaseOrders'),
    props,
    returnUrl,
    'Generate Receipt Labels',
    job => onDocumentPrintComplete(state, props, job),
    job => onDocumentPrintFailed(state, props, job)
  );
}

export function reprintRange(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;

  createBackgroundJob(
    GoodsReceiptLineLabel.reprint,
    getRangeMutationProps(state, props, variables, 'goodsReceiptLabel'),
    props,
    returnUrl,
    'Generate Goods Receipt Labels',
    job => onDocumentPrintComplete(state, props, job)
  );
}
